import GooglePreviewBaseController from "./google_preview_base_controller"
import { gatherCardTypeFormData } from "./gather_design_form_data"
import { setupPreviewLayout, setupZoneClicks } from "./design_form_support"
import { buildGooglePreviewState } from "./preview_state_builder"

export default class GoogleCardPreviewDesignController extends GooglePreviewBaseController {
  connect() {
    this.form = this.element.closest("form")
    if (!this.form) return
    this.form.setAttribute("enctype", "multipart/form-data")
    setupPreviewLayout(this.element)
    this.teardownZones = setupZoneClicks(this.element, this.form)
    this.onForm = () => this.refresh()
    ;["input", "change"].forEach((eventType) => {
      this.form.addEventListener(eventType, this.onForm)
    })
    this.form.addEventListener("card-type-image-update", this.onForm)
    this.refresh()
  }

  disconnect() {
    if (this.form) {
      ;["input", "change"].forEach((eventType) => {
        this.form.removeEventListener(eventType, this.onForm)
      })
      this.form.removeEventListener("card-type-image-update", this.onForm)
    }
    if (this.teardownZones) this.teardownZones()
    this.releaseObjectUrls()
  }

  refresh() {
    this.applyGooglePreview(buildGooglePreviewState(gatherCardTypeFormData(this.form)))
  }
}
